import React, { Fragment } from "react";
import EAButton from "./EAButton";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import Popper from "@material-ui/core/Popper";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";

/**
 * Komponente, welche bei Klick ein Drop-Down zur Verfügung stellt.
 * Beim anklicken einer Option wird eine Funktion mit dem entsprechenden Index und der Bezeichnung der ausgewählten Option
 * als Parameter aufgerufen
 * @param id
 * @param label
 * @param options die anzuzeigenden Optionen(Strings)
 * @param onItemClick(index)
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */
function EASelectButton({ id, label, options, onItemClick, ...rest }) {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const handleMenuItemClick = (event, index) => {
        onItemClick(index, options[index]);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };
    return (
        <div id={id + "wrapper"} ref={anchorRef}>
            <EAButton
                id={id}
                label={
                    <Fragment>
                        {label} <ArrowDropDownIcon />
                    </Fragment>
                }
                aria-controls={open ? id + "-split-button-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                onClick={handleToggle}
                {...rest}
            />
            <Popper style={{ zIndex: 999 }} open={open} anchorEl={anchorRef.current} role={undefined} transition>
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === "bottom" ? "center top" : "center bottom",
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList id={id + "-split-button-menu"}>
                                    {options.map((option, index) => (
                                        <MenuItem key={option} onClick={(event) => handleMenuItemClick(event, index)}>
                                            {option}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </div>
    );
}

export default EASelectButton;
